import React, { FC } from 'react';
import { Snackbar, Button } from '@material-ui/core';
import { register } from '../serviceWorker';

const ServiceWorkerWrapper = () => {
  const [showReload, setShowReload] = React.useState(false);
  const [installingWorker, setInstallingWorker] = React.useState(null);

  const onSWUpdate = (registration) => {
    setShowReload(true);
    const worker = registration.installing || registration.waiting;
    setInstallingWorker(worker);
    setTimeout(function(){
      reloadPage();
    }, 2000)
  };

  React.useEffect(() => {
    register({ onUpdate: onSWUpdate });
  }, []);

  const reloadPage = () => {
    if (installingWorker) {
      installingWorker.postMessage({ type: 'SKIP_WAITING' });
    }
    setShowReload(false);
    window.location.reload(true);
  };

  return (
    <Snackbar
      open={showReload}
      message="A new version is available! Reloading..."
      onClick={reloadPage}
      data-test-id="screens-new-version-snackbar"
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    />
  );
}
export default ServiceWorkerWrapper;